import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { UserController } from 'src/controllers/user.controller'
import { UserParams } from 'src/domain/User/UserDomain'

const userController = new UserController()

export function useChangeProfile() {
  const { userFarm: farmId } = useAuth()
  return useMutation({
    mutationKey: ['changeProfile'],
    mutationFn: (changeProfileDto: UserParams) => userController.changeProfile(farmId!, changeProfileDto),
    onError: () => {
      toast.error('Erro ao atualizar perfil')
    }
  })
}
